import styled from 'styled-components'

import ResponsiveVideo from '@babelcoder/gatsby-theme-base/src/components/ResponsiveVideo'

const VideoPlayer = styled(ResponsiveVideo)`
  border-radius: ${({ theme }) => theme.round.large};
  overflow: hidden;
`

export default VideoPlayer
